import React from 'react';
import { useDraggable, useDroppable } from '@dnd-kit/core';
import { CSS } from '@dnd-kit/utilities';

export type OfferRowDragHandleProps = {
  setNodeRef: (node: HTMLElement | null) => void;
  style: React.CSSProperties;
  attributes: ReturnType<typeof useDraggable>['attributes'];
  listeners: ReturnType<typeof useDraggable>['listeners'];
};

/**
 * Positionszeile für Dokument- und Kalkulationsansicht: gleichzeitig Drag-Quelle und
 * Drop-Ziel, damit die Reihenfolge in beiden Tabellen über dieselbe DndContext-Logik läuft.
 */
export function DraggableOfferRow({
  id,
  rowId,
  children,
}: {
  id: string;
  rowId: string;
  children: (props: OfferRowDragHandleProps) => React.ReactNode;
}) {
  const { attributes, listeners, setNodeRef: setDragRef, transform, isDragging } = useDraggable({
    id,
    data: { source: 'row', rowId },
  });
  const { setNodeRef: setDropRef } = useDroppable({ id });
  const setNodeRef = React.useCallback(
    (node: HTMLElement | null) => {
      setDragRef(node);
      setDropRef(node);
    },
    [setDragRef, setDropRef],
  );
  const style: React.CSSProperties = {
    transform: CSS.Translate.toString(transform),
    opacity: isDragging ? 0.6 : 1,
  };
  return <>{children({ setNodeRef, style, attributes, listeners })}</>;
}
